<template>
  <svg :width="width"
       :height="height"
       viewBox="0 0 194 158"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
      <path d="M148.64 15H163.64V0H178.64V15H193.64V30H178.64V45H163.64V30H148.64V15ZM33.36 15H133.64V30H33.36C28.5901 30.0132 24.0194 31.9139 20.6466 35.2867C17.2738 38.6595 15.3732 43.2302 15.36 48V142.08H145.64C150.41 142.067 154.981 140.166 158.353 136.793C161.726 133.421 163.627 128.85 163.64 124.08V60H178.64V124.08C178.624 132.827 175.142 141.212 168.957 147.397C162.772 153.582 154.387 157.064 145.64 157.08H0.359985V48C0.375846 39.2527 3.85771 30.8683 10.043 24.683C16.2282 18.4977 24.6127 15.0159 33.36 15ZM145.64 88C144.97 75.39 135.42 66.11 120.37 66.11C103.71 66.11 93.07 77.21 93.07 95.11C93.07 113.26 103.71 124.16 120.47 124.16C135.1 124.16 144.92 115.71 145.69 102.58H131.58C130.64 108.64 126.71 112.27 120.58 112.27C113.05 112.27 108.38 106.05 108.38 95.11C108.38 84.36 113.05 78.03 120.53 78.03C126.74 78.03 130.64 82.18 131.53 88.03L145.64 88ZM33.36 122.89H48.5V91.13C48.5 83.82 52.72 78.78 59.87 78.78C66.78 78.78 70.31 83.14 70.31 90.3V122.89H85.45V87.09C85.45 74.21 78.45 66.23 66.06 66.23C57.59 66.23 51.51 70.16 48.56 77.17H48.25V48H33.36V122.89Z" :fill="color"/>
  </svg>
</template>
<script>
export default {
  name: 'LogoExit',
  props: {
    color: {
      type: String,
      default: '#fff'
    },
    width: {
      type: Number,
      default: 40
    },
    height: {
      type: Number,
      default: 40
    }
  }
};
</script>
